import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Loading from "../../utils/loading/Loading";
import PlayCircleOutlineIcon from "@material-ui/icons/PlayCircleOutline";
import {
  patientRequest,
  getCategoriesRequest1,
  getCategoryVideosRequest1,
} from "../actions";
import styles from "../VideoChooser.scss";
import mur from "../WallVideo.scss";

// Modal Videos
import Modal from "../ModalVideo";
import edit from "../ModalVideo.scss";

// jQuery
import poster1 from "../../playlists/posterImage/thumb.png";
import MaterialIcon from "material-icons-react";
import { getSubdomainUrl } from "../PatientPlaylistTools";

const CategoryVideos = ({
  getCategoryVideosRequest1,
  videos,
  getCategoriesRequest1,
  categoryVideosRequesting,
  categoryVideosSuccessful,
  patientRequest,
  categories,
  authData,
  categoryVideosError /* Source iframe by ShowModal(SRC) */,
  ...props
}) => {
  const [category, setCategory] = useState(null);
  const [modal, setModal] = useState({ isShown: false, currentVideo: null });

  useEffect(() => {
    const sd = getSubdomainUrl();
    patientRequest({ subdomain: sd });
    getCategoriesRequest1();
  }, [getCategoriesRequest1, patientRequest]);

  useEffect(() => {
    if (categories && categories.length) {
      const categorySlugParam =
        props.match && props.match.params && props.match.params.categorySlug;

      if (categorySlugParam && categories && categories.length) {
        const [selectedCategory] = categories.filter(
          (category) => category.slug === categorySlugParam
        );
        if (selectedCategory) {
          setCategory(selectedCategory);
        }
      }
    }
  }, [categories]);

  useEffect(() => {
    if (authData && category) {
      const userId = authData.id;
      const categoryId = category.id;
      getCategoryVideosRequest1({ userId, categoryId });
    }
  }, [authData, category]);

  const showModal = (video) => {
    const sourceFile = video.file;
    if (!sourceFile) {
      return;
    }

    setModal({ isShown: true, currentVideo: video });
  };

  const hideModal = () => {
    setModal({ isShown: false, currentVideo: null });
  };

  const viewDoctorInfos = () => {
    props.history.push("/info-doctor", {});
  };

  return (
    <React.Fragment>
      {category && categoryVideosSuccessful && (
        <div className={styles.videoView}>
          <a className={styles.active} onClick={() => props.history.goBack()}>
            <MaterialIcon
              color="#ffffff"
              icon="keyboard_arrow_left"
              size={40}
            />
          </a>
          <p>{category.name}</p>
          <a
            id={styles.IconInfo}
            className={styles.active}
            onClick={viewDoctorInfos}
          >
            <MaterialIcon color="#ffffff" icon="info" size={40} />
          </a>
        </div>
      )}

      {!category && categoryVideosRequesting && <Loading size={80} />}
      <div style={{ paddingTop: "3em" }}>
        {categoryVideosSuccessful &&
          videos
            .filter((video) => video.autoGeneratedForVideoWall != true)
            .map((video) => (
              <article
                className={mur.video}
                id={styles.playDisplay}
                key={video.id}
                onClick={(e) => showModal(video)}
              >
                <figure id={mur.pop_up}>
                  {/* Picture on the card */}
                  <a className={mur.fancybox}>
                    <img
                      className={mur.videoThumb}
                      src={
                        video.posterImage === undefined
                          ? poster1
                          : video.posterImage
                      }
                    />
                  </a>
                  <a
                    id={styles.iconPlayer}
                    style={{
                      position: "absolute",
                      top: "38%",
                      left: "50%",
                      transform: "translate(-50 %, -50 %)",
                      msTransform: "translate(-50%, -50%)",
                      color: "#555",
                      padding: "12px 24px",
                      border: "none",
                      opacity: "0",
                      transition: "0.5s",
                    }}
                  >
                    <PlayCircleOutlineIcon id={styles.sizePlayer} />
                  </a>
                </figure>
                {/* Title card */}
                <h2 className={mur.videoTitle}> {video.description}</h2>
              </article>
            ))}
      </div>
      {/* Modal with component Iframe */}
      {modal.isShown && (
        <div>
          {console.log("CERERER ", modal.currentVideo.file)}
          <Modal
            srcIframe={modal.currentVideo.file}
            backToTheWall={() => hideModal()}
          />
          <div
            className={edit.modal_video}
            id={edit.contentModal}
            onClick={(e) => hideModal()}
          />
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  videos: state["video-patient"].videos,
  authData: state["video-patient"].authData,
  categories: state["video-patient"].categories,
  categoryVideosRequesting: state["video-patient"].categoryVideosRequesting,
  categoryVideosSuccessful: state["video-patient"].categoryVideosSuccessful,
  categoryVideosError: state["video-patient"].categoryVideosError,
});

export default connect(mapStateToProps, {
  getCategoriesRequest1,
  patientRequest,
  getCategoryVideosRequest1,
})(CategoryVideos);



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/categoryVideos/CategoryVideos.jsx